import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./upcoming.css";
import Popupboxx from "../Popupbox/Popupbox";

function Upcoming() {
  const [batches, setBatches] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Initialize AOS
    AOS.init({ duration: 800, once: true });

    const generateMonthlyBatches = () => {
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);

      const newBatches = [];
      const gapDays = 3;
      let id = 1;

      const onlyDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      for (
        let d = new Date(startOfMonth);
        d < nextMonth;
        d.setDate(d.getDate() + gapDays)
      ) {
        if (d >= onlyDate) {
          newBatches.push({
            id: id++,
            date: d.toLocaleDateString("en-GB"),
            day: d.toLocaleDateString("en-US", { weekday: "long" }),
            mode: "Offline / Online",
            link: "#",
          });
        }
      }

      setBatches(newBatches);
    };

    generateMonthlyBatches();

    const monthChecker = setInterval(() => {
      const now = new Date();
      if (now.getDate() === 1) {
        generateMonthlyBatches();
      }
    }, 86400000);

    return () => clearInterval(monthChecker);
  }, []);

  return (
    <>
      <section className="upcoming-section">
        <div className="container-change">

          <section className="section-margin">
            <div className="headlines-for-all" data-aos="fade-up">
              <h4>
                <span>Upcoming </span> Batches
              </h4>
            </div>
          </section>

          <div className="table-container" data-aos="fade-up" data-aos-delay="100">
            <table className="batch-table">
              <thead>
                <tr>
                  <th className="table-head">No</th>
                  <th>Date</th>
                  <th>Day</th>
                  <th>Mode</th>
                  <th>Link</th>
                </tr>
              </thead>

              <tbody>
                {batches.length > 0 ? (
                  batches.map((batch, i) => (
                    <tr key={batch.id} data-aos="fade-up" data-aos-delay={150 + i * 50}>
                      <td className="table-head">{batch.id}</td>
                      <td>{batch.date}</td>
                      <td>{batch.day}</td>
                      <td>{batch.mode}</td>
                      <td>
                        <a
                          href={batch.link}
                          className="click-link"
                          onClick={(e) => {
                            e.preventDefault();
                            setIsPopupOpen(true);
                          }}
                        >
                          Click Here
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr data-aos="fade-up" data-aos-delay="150">
                    <td colSpan="5">No Upcoming Batches</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <Popupboxx isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default Upcoming;
